import { render, staticRenderFns } from "./LISRejectReason.vue?vue&type=template&id=6577a095&scoped=true"
import script from "./LISRejectReason.vue?vue&type=script&lang=js"
export * from "./LISRejectReason.vue?vue&type=script&lang=js"
import style0 from "./LISRejectReason.vue?vue&type=style&index=0&id=6577a095&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6577a095",
  null
  
)

export default component.exports